/** health: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "cause_decoder": "the display couldn't start its video decoder (often more videos on screen at once than it can decode, or a format it can't handle)",
  "cause_slow_start": "it took too long to start",
  "cause_format": "the display can't play this format",
  "cause_refused": "the display refused to start it",
  "cause_other": "it downloaded but won't play",
  "sev_critical": "Critical",
  "sev_warning": "Warning",
  "sev_info": "Info",
  "kind_player": "Player",
  "kind_campaign": "Campaign",
  "kind_playlist": "Playlist",
  "kind_media": "Media",
  "kind_publication": "Publication",
  "kind_feed": "Data feed",
  "gPlayers": "Players",
  "gContent": "Content",
  "gFeeds": "Data feeds",
  "turnOff": "Turn off",
  "vitalOffQ": "Turn off “{name}”? It means a screen is blank or showing the wrong thing, so you won't hear about that any more, and alerts on it stop. Open issues of this kind are resolved.",
  "nOff": "{n} check is turned off. | {n} checks are turned off.",
  "manageChecks": "Manage checks",
  "alertCheckOff": "This check is turned off in Health checks, so this alert won't fire.",
  "nOfMOn": "{n} of {m} on",
  "allOn": "Turn all on",
  "vital": "Blank screen",
  "vitalHint": "Means a screen is blank or showing the wrong thing",
  "dShort": "{n} day | {n} days",
  "hShort": "{n} h",
  "mShort": "{n} min",
  "desc_PLAYER_OFFLINE": "The player stopped reporting in.",
  "desc_PLAYER_NEVER_CONNECTED": "Paired, but it has never reported in.",
  "desc_PLAYER_OUT_OF_SYNC": "Not playing the latest published content yet.",
  "desc_PLAYER_FALLBACK": "Showing its fallback screen instead of content.",
  "desc_PLAYER_NOT_ON_SCREEN": "Running, but another app or the home screen is in front of it: the display isn't showing your content.",
  "desc_PLAYER_FILES_FAILED": "Some content files didn't download.",
  "desc_PLAYER_STORAGE_LOW": "Running out of space for content.",
  "desc_PLAYER_ERROR_SPIKE": "Reporting an unusual number of errors.",
  "desc_PLAYER_APP_OUTDATED": "Running an older player app than your other players.",
  "desc_PLAYER_NO_CONTENT": "Nothing is published to it.",
  "desc_PLAYER_LOCATION_MISSING": "A region applies but it has no location set.",
  "desc_PLAYER_CANT_DOWNLOAD": "New content has failed to download for 5 minutes.",
  "desc_PLAYER_CONTENT_REJECTED": "New content arrived but failed the player's checks.",
  "desc_CONTENT_BROKEN": "Players can't download or play an item.",
  "desc_CAMPAIGN_EMPTY_ZONE": "A campaign has a section with nothing in it.",
  "desc_PLAYLIST_EMPTY": "A published playlist has no items.",
  "desc_MEDIA_FAILED": "An upload couldn't be prepared for players.",
  "desc_PUBLICATION_EXPIRED": "A publication's end date has passed.",
  "desc_MEDIA_FILE_MISSING": "A published item's file is gone or unreachable.",
  "desc_FEED_FAILING": "A data feed's source failed 3 checks in a row.",
  "code_PLAYER_OFFLINE": "Player offline",
  "code_PLAYER_NEVER_CONNECTED": "Never connected",
  "code_PLAYER_OUT_OF_SYNC": "Out of sync",
  "code_PLAYER_FALLBACK": "Showing fallback",
  "code_PLAYER_NOT_ON_SCREEN": "Not on screen",
  "code_PLAYER_FILES_FAILED": "Files failed",
  "code_PLAYER_STORAGE_LOW": "Storage low",
  "code_PLAYER_ERROR_SPIKE": "Error spike",
  "code_PLAYER_APP_OUTDATED": "App outdated",
  "code_PLAYER_NO_CONTENT": "Nothing to play",
  "code_PLAYER_LOCATION_MISSING": "Location missing",
  "code_CAMPAIGN_EMPTY_ZONE": "Campaign with an empty section",
  "code_PLAYLIST_EMPTY": "Empty playlist",
  "code_MEDIA_FAILED": "Media failed",
  "code_PUBLICATION_EXPIRED": "Publication expired",
  "code_FEED_FAILING": "Data feed failing",
  "code_CONTENT_BROKEN": "Broken content",
  "code_MEDIA_FILE_MISSING": "File missing",
  "code_PLAYER_CANT_DOWNLOAD": "Can't download content",
  "code_PLAYER_CONTENT_REJECTED": "Content rejected",
  "msg_cantDownload": "Can't download content: {why}",
  "msg_contentRejected": "New content failed the player's checks",
  "fixItem": "Open the item",
  "yes": "Yes",
  "no": "No",
  "fact_failed": "Files failed",
  "fact_reason": "Reason",
  "fact_detail": "Detail",
  "fact_syncError": "Why",
  "fact_since": "Failing since",
  "fact_current": "Latest version",
  "fact_playing": "Playing version",
  "fact_freePercent": "Free storage (%)",
  "fact_players": "Players affected",
  "fact_playerNames": "Players",
  "fact_revision": "Content version",
  "fact_minutes": "Minutes",
  "fact_lastSeenAt": "Last seen",
  "msg_brokenDownload": "Can't be downloaded on {n} player ({names}): {why} | Can't be downloaded on {n} players ({names}): {why}",
  "msg_brokenPlay": "Won't play on {n} player ({names}): {why} | Won't play on {n} players ({names}): {why}",
  "why_unreachable": "its file's address can't be reached",
  "why_not_found": "its file doesn't exist on the server",
  "why_http_error": "the server returned an error for its file",
  "why_corrupt": "its file arrived damaged",
  "why_playback_failed": "it downloaded but won't play",
  "msg_fileMissing": "Published, but its file is missing from storage: players can't download it",
  "msg_fileUnreachable": "Published, but its file's address can't be reached ({detail})",
  "fixConnection": "Check connection",
  "fixPairing": "Check pairing",
  "fixSync": "See sync status",
  "fixErrors": "See errors",
  "fixNotOnScreen": "See the screen",
  "fixStorage": "See storage",
  "fixApp": "See app version",
  "fixContent": "Open its content",
  "fixLocation": "Set its location",
  "fixCampaign": "Edit campaign",
  "fixPlaylist": "Edit playlist",
  "fixFind": "Find it in Content",
  "fixList": "Open its list",
  "fixGroups": "Open player groups",
  "fixFeed": "Open the feed",
  "min": "{n} min",
  "h": "{n} h",
  "hMin": "{h} h {m} min",
  "d": "{n} d",
  "uMin": "min",
  "uH": "h",
  "ackedN": "Acknowledged {n} issue · they come back if they get worse | Acknowledged {n} issues · they come back if they get worse",
  "undo": "Undo",
  "checkedAgo": "checked {ago} ago",
  "intro": "Problems with your players and content, worst first. Checked every minute · {last}.",
  "st_open": "Open",
  "st_resolved": "Resolved",
  "hideAcked": "Hide acknowledged ({n})",
  "nSelected": "{n} selected",
  "countOpen": "{n} open issue | {n} open issues",
  "countResolved": "{n} resolved issue | {n} resolved issues",
  "selectX": "Select {name}",
  "forX": "· for {d}",
  "offlineForX": "· last seen {d} ago",
  "resolvedAgo": "· resolved {ago} ago (lasted {d})",
  "ackedBy": "· acknowledged by {name}",
  "someone": "someone",
  "hiddenN": "{n} acknowledged issue is hidden. | {n} acknowledged issues are hidden.",
  "msg_PLAYER_LOCATION_MISSING": "A region restriction applies, but the player has no location, so it is inside no region",
  "msg_PLAYER_NEVER_CONNECTED": "Paired, but the player has never connected",
  "msg_PLAYER_OFFLINE": "The player is offline",
  "msg_PLAYER_NO_CONTENT": "Nothing to play: the content list is empty, or every item is restricted out for this player",
  "msg_PLAYLIST_EMPTY": "A published playlist has nothing to play",
  "msg_downloading": "Still downloading the latest content",
  "msg_notLatest": "Not playing the latest content",
  "msg_PLAYER_FALLBACK": "Showing fallback content ({reason})",
  "msg_PLAYER_NOT_ON_SCREEN": "Another app or the home screen is in front of the player",
  "msg_PLAYER_FILES_FAILED": "{n} content file failed to download or verify | {n} content files failed to download or verify",
  "msg_PLAYER_STORAGE_LOW": "Storage almost full ({n} % free)",
  "msg_PLAYER_ERROR_SPIKE": "{n} error in the last hour | {n} errors in the last hour",
  "msg_PLAYER_APP_OUTDATED": "Runs app {version}; {newest} is the newest in your organization",
  "msg_CAMPAIGN_EMPTY_ZONE": "{n} section is empty in a published campaign | {n} sections are empty in a published campaign",
  "msg_mediaUsed": "Processing failed, and the item is in use",
  "msg_mediaFailed": "Processing failed",
  "msg_PUBLICATION_EXPIRED": "Its restriction ended on {date}: it will not play again",
  "msg_FEED_FAILING": "The source failed {n} check in a row | The source failed {n} checks in a row",
  "backInList": "Back in the list",
  "checkValues": "Check the values: each must be a whole number in its range.",
  "thresholdsSaved": "Health checks saved · they apply from the next check (within a minute)",
  "notChecked": "not checked yet",
  "title": "Health Check",
  "thresholds": "Checks & thresholds",
  "checking": "Checking…",
  "recheck": "Re-check now",
  "filterSev": "Filter by severity",
  "state": "State",
  "kind": "Kind",
  "allKinds": "All kinds",
  "search": "Search",
  "searchPh": "Search by name or problem",
  "retry": "Retry",
  "ack": "Acknowledge",
  "unack": "Un-acknowledge",
  "clear": "Clear",
  "selectAll": "Select all",
  "noMatch": "No open issues match these filters.",
  "healthy": "No issues found. Everything looks healthy.",
  "noResolved": "No resolved issues yet.",
  "loading": "Loading…",
  "loadMore": "Load more",
  "thresholdsTitle": "Health checks",
  "thresholdsDesc": "Which checks run, and when a player counts as having a problem. Applies to the whole organization.",
  "reset": "Reset to defaults",
  "cancel": "Cancel",
  "saving": "Saving…",
  "save": "Save",
  "fOffline": "Offline after",
  "fOfflineHint": "A paired player that is silent this long is offline (default 1 day = 1440 min). Critical when silent twice as long, and never before an hour.",
  "fSync": "Out of sync after",
  "fSyncHint": "Time a player may take to start playing newly published content.",
  "fStorage": "Storage low below",
  "fStorageHint": "Critical below 3 %.",
  "fErrors": "Error spike at",
  "fErrorsHint": "Player errors in the last hour.",
  "fNever": "Never connected after",
  "fNeverHint": "Paired, but no heartbeat yet.",
  "uFree": "% free",
  "uErrH": "errors / hour"
};
const ar: typeof en = {
  "cause_decoder": "تعذّر على الشاشة تشغيل مفكّك ترميز الفيديو (غالبًا بسبب عرض فيديوهات في الوقت نفسه أكثر مما تستطيع، أو صيغة لا تدعمها)",
  "cause_slow_start": "استغرق بدء التشغيل وقتًا طويلًا",
  "cause_format": "لا تستطيع الشاشة تشغيل هذه الصيغة",
  "cause_refused": "رفضت الشاشة تشغيله",
  "cause_other": "تم تنزيله لكنه لا يعمل",
  "sev_critical": "حرج",
  "sev_warning": "تحذير",
  "sev_info": "معلومة",
  "kind_player": "مشغل",
  "kind_campaign": "حملة",
  "kind_playlist": "قائمة تشغيل",
  "kind_media": "وسائط",
  "kind_publication": "نشر",
  "kind_feed": "مصدر بيانات",
  "gPlayers": "المشغلات",
  "gContent": "المحتوى",
  "gFeeds": "مصادر البيانات",
  "turnOff": "إيقاف",
  "vitalOffQ": "إيقاف «{name}»؟ يعني هذا أن شاشة فارغة أو تعرض شيئًا خاطئًا، فلن تُبلَّغ بذلك بعد الآن وتتوقف التنبيهات عليه. تُحل المشكلات المفتوحة من هذا النوع.",
  "nOff": "{n} فحص متوقف. | {n} فحوصات متوقفة.",
  "manageChecks": "إدارة الفحوصات",
  "alertCheckOff": "هذا الفحص متوقف في فحوصات الحالة، لذلك لن يعمل هذا التنبيه.",
  "nOfMOn": "{n} من {m} مفعّلة",
  "allOn": "تشغيل الكل",
  "vital": "شاشة فارغة",
  "vitalHint": "يعني أن شاشة فارغة أو تعرض شيئًا خاطئًا",
  "dShort": "يوم {n} | {n} أيام",
  "hShort": "{n} س",
  "mShort": "{n} د",
  "desc_PLAYER_OFFLINE": "توقف المشغل عن الإبلاغ.",
  "desc_PLAYER_NEVER_CONNECTED": "مقترن لكنه لم يُبلغ قط.",
  "desc_PLAYER_OUT_OF_SYNC": "لا يعرض أحدث محتوى منشور بعد.",
  "desc_PLAYER_FALLBACK": "يعرض الشاشة الاحتياطية بدل المحتوى.",
  "desc_PLAYER_NOT_ON_SCREEN": "يعمل، لكن تطبيقًا آخر أو الشاشة الرئيسية أمامه: الشاشة لا تعرض محتواك.",
  "desc_PLAYER_FILES_FAILED": "لم يتم تنزيل بعض ملفات المحتوى.",
  "desc_PLAYER_STORAGE_LOW": "المساحة المتاحة للمحتوى تنفد.",
  "desc_PLAYER_ERROR_SPIKE": "يُبلغ عن عدد غير معتاد من الأخطاء.",
  "desc_PLAYER_APP_OUTDATED": "يشغّل إصدارًا أقدم من تطبيق المشغل.",
  "desc_PLAYER_NO_CONTENT": "لم يُنشر إليه شيء.",
  "desc_PLAYER_LOCATION_MISSING": "تنطبق عليه منطقة لكن بلا موقع محدد.",
  "desc_PLAYER_CANT_DOWNLOAD": "فشل تنزيل المحتوى الجديد لمدة 5 دقائق.",
  "desc_PLAYER_CONTENT_REJECTED": "وصل محتوى جديد لكنه لم يجتز فحوصات المشغل.",
  "desc_CONTENT_BROKEN": "لا تستطيع المشغلات تنزيل عنصر أو تشغيله.",
  "desc_CAMPAIGN_EMPTY_ZONE": "في حملة قسم فارغ.",
  "desc_PLAYLIST_EMPTY": "قائمة تشغيل منشورة بلا عناصر.",
  "desc_MEDIA_FAILED": "تعذّر تجهيز ملف مرفوع للمشغلات.",
  "desc_PUBLICATION_EXPIRED": "انقضى تاريخ انتهاء النشر.",
  "desc_MEDIA_FILE_MISSING": "ملف عنصر منشور مفقود أو لا يمكن الوصول إليه.",
  "desc_FEED_FAILING": "فشل مصدر البيانات في 3 فحوصات متتالية.",
  "code_PLAYER_OFFLINE": "المشغل غير متصل",
  "code_PLAYER_NEVER_CONNECTED": "لم يتصل قط",
  "code_PLAYER_OUT_OF_SYNC": "غير متزامن",
  "code_PLAYER_FALLBACK": "يعرض الشاشة الاحتياطية",
  "code_PLAYER_NOT_ON_SCREEN": "ليس على الشاشة",
  "code_PLAYER_FILES_FAILED": "فشل تنزيل ملفات",
  "code_PLAYER_STORAGE_LOW": "مساحة التخزين منخفضة",
  "code_PLAYER_ERROR_SPIKE": "ارتفاع مفاجئ في الأخطاء",
  "code_PLAYER_APP_OUTDATED": "التطبيق قديم",
  "code_PLAYER_NO_CONTENT": "لا شيء للعرض",
  "code_PLAYER_LOCATION_MISSING": "الموقع غير محدد",
  "code_CAMPAIGN_EMPTY_ZONE": "حملة بقسم فارغ",
  "code_PLAYLIST_EMPTY": "قائمة تشغيل فارغة",
  "code_MEDIA_FAILED": "فشل معالجة الوسائط",
  "code_PUBLICATION_EXPIRED": "انتهت مدة النشر",
  "code_FEED_FAILING": "مصدر البيانات يفشل",
  "code_CONTENT_BROKEN": "محتوى معطّل",
  "code_MEDIA_FILE_MISSING": "ملف مفقود",
  "code_PLAYER_CANT_DOWNLOAD": "تعذّر تنزيل المحتوى",
  "code_PLAYER_CONTENT_REJECTED": "محتوى مرفوض",
  "msg_cantDownload": "تعذّر تنزيل المحتوى: {why}",
  "msg_contentRejected": "لم يجتز المحتوى الجديد فحوصات المشغّل",
  "fixItem": "افتح العنصر",
  "yes": "نعم",
  "no": "لا",
  "fact_failed": "الملفات المتعذّرة",
  "fact_reason": "السبب",
  "fact_syncError": "السبب",
  "fact_since": "يفشل منذ",
  "fact_current": "أحدث إصدار",
  "fact_playing": "الإصدار المعروض",
  "fact_detail": "التفاصيل",
  "fact_freePercent": "المساحة الحرة (%)",
  "fact_players": "المشغّلات المتأثرة",
  "fact_playerNames": "المشغّلات",
  "fact_revision": "إصدار المحتوى",
  "fact_minutes": "الدقائق",
  "fact_lastSeenAt": "آخر ظهور",
  "msg_brokenDownload": "تعذّر تنزيله على {n} مشغل ({names}): {why} | تعذّر تنزيله على {n} مشغلات ({names}): {why}",
  "msg_brokenPlay": "لا يعمل على {n} مشغل ({names}): {why} | لا يعمل على {n} مشغلات ({names}): {why}",
  "why_unreachable": "لا يمكن الوصول إلى عنوان ملفه",
  "why_not_found": "ملفه غير موجود على الخادم",
  "why_http_error": "أعاد الخادم خطأً لملفه",
  "why_corrupt": "وصل ملفه تالفًا",
  "why_playback_failed": "تم تنزيله لكنه لا يعمل",
  "msg_fileMissing": "منشور، لكن ملفه مفقود من التخزين: لا تستطيع المشغلات تنزيله",
  "msg_fileUnreachable": "منشور، لكن لا يمكن الوصول إلى عنوان ملفه ({detail})",
  "fixConnection": "تحقق من الاتصال",
  "fixPairing": "تحقق من الإقران",
  "fixSync": "عرض حالة المزامنة",
  "fixErrors": "عرض الأخطاء",
  "fixNotOnScreen": "عرض الشاشة",
  "fixStorage": "عرض التخزين",
  "fixApp": "عرض إصدار التطبيق",
  "fixContent": "فتح محتواه",
  "fixLocation": "تحديد موقعه",
  "fixCampaign": "تعديل الحملة",
  "fixPlaylist": "تعديل قائمة التشغيل",
  "fixFind": "ابحث عنه في المحتوى",
  "fixList": "فتح قائمته",
  "fixGroups": "فتح مجموعات المشغلات",
  "fixFeed": "فتح المصدر",
  "min": "{n} د",
  "h": "{n} س",
  "hMin": "{h} س {m} د",
  "d": "{n} ي",
  "uMin": "دقيقة",
  "uH": "ساعة",
  "ackedN": "تم الإقرار بـ {n} مشكلات · تعود إذا ساءت | تم الإقرار بمشكلة واحدة · تعود إذا ساءت | تم الإقرار بمشكلتين · تعودان إذا ساءتا | تم الإقرار بـ {n} مشكلات · تعود إذا ساءت | تم الإقرار بـ {n} مشكلة · تعود إذا ساءت | تم الإقرار بـ {n} مشكلة · تعود إذا ساءت",
  "undo": "تراجع",
  "checkedAgo": "فُحص قبل {ago}",
  "intro": "مشكلات مشغلاتك ومحتواك، الأسوأ أولًا. يُفحص كل دقيقة · {last}.",
  "st_open": "مفتوحة",
  "st_resolved": "محلولة",
  "hideAcked": "إخفاء المُقرّ بها ({n})",
  "nSelected": "{n} محدد",
  "countOpen": "لا مشكلات مفتوحة | مشكلة مفتوحة واحدة | مشكلتان مفتوحتان | {n} مشكلات مفتوحة | {n} مشكلة مفتوحة | {n} مشكلة مفتوحة",
  "countResolved": "لا مشكلات محلولة | مشكلة محلولة واحدة | مشكلتان محلولتان | {n} مشكلات محلولة | {n} مشكلة محلولة | {n} مشكلة محلولة",
  "selectX": "تحديد {name}",
  "forX": "· منذ {d}",
  "offlineForX": "· آخر ظهور منذ {d}",
  "resolvedAgo": "· حُلّت قبل {ago} (استمرت {d})",
  "ackedBy": "· أقرّ بها {name}",
  "someone": "شخص ما",
  "hiddenN": "لا مشكلات مخفية. | مشكلة مُقرّ بها واحدة مخفية. | مشكلتان مُقرّ بهما مخفيتان. | {n} مشكلات مُقرّ بها مخفية. | {n} مشكلة مُقرّ بها مخفية. | {n} مشكلة مُقرّ بها مخفية.",
  "msg_PLAYER_LOCATION_MISSING": "ينطبق قيد منطقة، لكن المشغل بلا موقع، لذا فهو خارج كل المناطق",
  "msg_PLAYER_NEVER_CONNECTED": "مقترن، لكن المشغل لم يتصل قط",
  "msg_PLAYER_OFFLINE": "المشغل غير متصل",
  "msg_PLAYER_NO_CONTENT": "لا شيء للعرض: قائمة المحتوى فارغة، أو كل العناصر مقيّدة على هذا المشغل",
  "msg_PLAYLIST_EMPTY": "قائمة تشغيل منشورة ليس فيها ما يُعرض",
  "msg_downloading": "ما زال ينزّل أحدث محتوى",
  "msg_notLatest": "لا يعرض أحدث محتوى",
  "msg_PLAYER_FALLBACK": "يعرض المحتوى الاحتياطي ({reason})",
  "msg_PLAYER_NOT_ON_SCREEN": "تطبيق آخر أو الشاشة الرئيسية أمام المشغل",
  "msg_PLAYER_FILES_FAILED": "لم يفشل أي ملف | فشل تنزيل ملف محتوى واحد أو التحقق منه | فشل تنزيل ملفَي محتوى أو التحقق منهما | فشل تنزيل {n} ملفات محتوى أو التحقق منها | فشل تنزيل {n} ملف محتوى أو التحقق منها | فشل تنزيل {n} ملف محتوى أو التحقق منها",
  "msg_PLAYER_STORAGE_LOW": "التخزين ممتلئ تقريبًا ({n}٪ متاحة)",
  "msg_PLAYER_ERROR_SPIKE": "لا أخطاء في الساعة الأخيرة | خطأ واحد في الساعة الأخيرة | خطآن في الساعة الأخيرة | {n} أخطاء في الساعة الأخيرة | {n} خطأً في الساعة الأخيرة | {n} خطأ في الساعة الأخيرة",
  "msg_PLAYER_APP_OUTDATED": "يعمل بالتطبيق {version}؛ والأحدث في مؤسستك {newest}",
  "msg_CAMPAIGN_EMPTY_ZONE": "لا أقسام فارغة | قسم واحد فارغ في حملة منشورة | قسمان فارغان في حملة منشورة | {n} أقسام فارغة في حملة منشورة | {n} قسمًا فارغًا في حملة منشورة | {n} قسم فارغ في حملة منشورة",
  "msg_mediaUsed": "فشلت المعالجة، والعنصر قيد الاستخدام",
  "msg_mediaFailed": "فشلت المعالجة",
  "msg_PUBLICATION_EXPIRED": "انتهى قيده في {date}: لن يُعرض مجددًا",
  "msg_FEED_FAILING": "لم يفشل المصدر | فشل المصدر في فحص واحد | فشل المصدر في فحصين متتاليين | فشل المصدر في {n} فحوص متتالية | فشل المصدر في {n} فحصًا متتاليًا | فشل المصدر في {n} فحص متتالٍ",
  "backInList": "عادت إلى القائمة",
  "checkValues": "تحقق من القيم: يجب أن تكون كل قيمة عددًا صحيحًا ضمن نطاقها.",
  "thresholdsSaved": "تم حفظ الفحوصات · تُطبَّق من الفحص التالي (خلال دقيقة)",
  "notChecked": "لم يُفحص بعد",
  "title": "فحص الحالة",
  "thresholds": "الفحوصات والحدود",
  "checking": "جارٍ الفحص…",
  "recheck": "إعادة الفحص الآن",
  "filterSev": "التصفية حسب الخطورة",
  "state": "الحالة",
  "kind": "النوع",
  "allKinds": "كل الأنواع",
  "search": "بحث",
  "searchPh": "البحث بالاسم أو المشكلة",
  "retry": "إعادة المحاولة",
  "ack": "إقرار",
  "unack": "إلغاء الإقرار",
  "clear": "مسح",
  "selectAll": "تحديد الكل",
  "noMatch": "لا توجد مشكلات مفتوحة تطابق هذه المرشحات.",
  "healthy": "لم تُعثر على مشكلات. كل شيء يبدو سليمًا.",
  "noResolved": "لا توجد مشكلات محلولة بعد.",
  "loading": "جارٍ التحميل…",
  "loadMore": "تحميل المزيد",
  "thresholdsTitle": "فحوصات الحالة",
  "thresholdsDesc": "أي الفحوصات تعمل، ومتى يُعدّ المشغل ذا مشكلة. ينطبق على المؤسسة كلها.",
  "reset": "إعادة إلى الافتراضي",
  "cancel": "إلغاء",
  "saving": "جارٍ الحفظ…",
  "save": "حفظ",
  "fOffline": "غير متصل بعد",
  "fOfflineHint": "المشغل المقترن الصامت هذه المدة يُعدّ غير متصل (الافتراضي يوم واحد = 1440 دقيقة). حرج عند صمته ضعف هذه المدة، وليس قبل ساعة.",
  "fSync": "غير متزامن بعد",
  "fSyncHint": "الوقت المسموح للمشغل لبدء عرض المحتوى المنشور حديثًا.",
  "fStorage": "التخزين منخفض تحت",
  "fStorageHint": "حرج تحت ٣٪.",
  "fErrors": "ارتفاع الأخطاء عند",
  "fErrorsHint": "أخطاء المشغل في الساعة الأخيرة.",
  "fNever": "لم يتصل قط بعد",
  "fNeverHint": "مقترن، لكن لم يُرسل نبضًا بعد.",
  "uFree": "٪ متاحة",
  "uErrH": "خطأ / ساعة"
};
export default { en, ar };
